export default __webpack_public_path__ + "static/media/endorsement-perpani-jaktim.87302c18.png";